import { apiService } from '@/shared/services/apiServices';

import {
  GetTemplateResult,
  PermissionsPayload,
  SaveTemplateResult,
  TemplateData,
} from '../types/permissionsType';

const TEMPLATES_ENDPOINT = 'policy-management/templates';

function extractError(response: { data?: unknown; status?: number }): string {
  if (response.status === 403) {
    return 'Brak uprawnień do zarządzania uprawnieniami.';
  }
  if (response.status === 400) {
    const data = response.data as { message?: string } | undefined;
    if (data?.message) {
      return data.message;
    }
  }
  return 'Nie udało się zapisać uprawnień. Spróbuj ponownie.';
}

export const permissionsApiService = {
  async saveTemplate(payload: PermissionsPayload): Promise<SaveTemplateResult> {
    const response = await apiService.patchAPI(TEMPLATES_ENDPOINT, payload);
    if (response.error) {
      return { success: false, error: extractError(response) };
    }
    return { success: true };
  },

  async getTemplate(): Promise<GetTemplateResult> {
    const response = await apiService.getAPI(TEMPLATES_ENDPOINT);
    if (response.error) {
      return { success: false, error: 'Nie udało się pobrać uprawnień.' };
    }
    const data = response.data as { template: TemplateData | null } | undefined;
    return { success: true, template: data?.template ?? null };
  },
};
